var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from "react";
import { FormattedMessage, FormattedDate, useIntl } from "react-intl";
import { Pane, Button, Icon, KeyValue, Row, Col, AccordionSet, Accordion, ConfirmationModal, Loading, Callout, } from "@folio/stripes/components";
import { useOkapiKy } from "@folio/stripes/core";
import { useQuery, useMutation, useQueryClient } from "react-query";
import { OrganizationStatusEnum } from "../types/api";
import { useModal } from "../utils/useModal";
import { getErrorInfo, isOptimisticLockConflict, } from "../utils/getErrorCode";
import { getOrganizationErrorMessageId, getLoadFailureMessageId, extractActiveUserCount, } from "../utils/getErrorMessageId";
import { isValidUuid } from "../utils/uuidUtils";
import { usePermissions } from "../utils/permissionsUtils";
import StatusBadge from "./StatusBadge";
import AuditLogAccordion from "./AuditLogAccordion";
import ActionErrorModal from "./ActionErrorModal";
var OrganizationDetailPane = function (_a) {
    var id = _a.id, onClose = _a.onClose, onEdit = _a.onEdit;
    var intl = useIntl();
    var ky = useOkapiKy();
    var queryClient = useQueryClient();
    var _b = useModal(), isErrorOpen = _b.isOpen, errorMessage = _b.message, openErrorModal = _b.openModal, closeErrorModal = _b.closeModal;
    var _c = usePermissions(), canEditOrganization = _c.canEditOrganization, canArchiveOrganization = _c.canArchiveOrganization;
    var _d = React.useState(false), showArchiveModal = _d[0], setShowArchiveModal = _d[1];
    var _e = React.useState(false), showRestoreModal = _e[0], setShowRestoreModal = _e[1];
    var _f = React.useState(false), showConflictModal = _f[0], setShowConflictModal = _f[1];
    var calloutRef = React.useRef(null);
    var isUuidValid = isValidUuid(id);
    var _g = useQuery(["czna-organizations", "organization", id], function () { return ky.get("czna-users/organizations/".concat(id)).json(); }, { enabled: isUuidValid }), organization = _g.data, isLoading = _g.isLoading, error = _g.error, refetch = _g.refetch;
    var archiveMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky.put("czna-users/organizations/".concat(id), {
                        json: {
                            name: organization.name,
                            sigla: organization.sigla,
                            status: OrganizationStatusEnum.INACTIVE,
                            version: organization.version,
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(["czna-organizations"]);
            (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
                type: "success",
                message: intl.formatMessage({
                    id: "ui-czna-users.organizations.archive.success",
                }),
            });
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo, messageId, values;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        errorInfo = _a.sent();
                        if (isOptimisticLockConflict(errorInfo)) {
                            setShowConflictModal(true);
                            return [2 /*return*/];
                        }
                        messageId = getOrganizationErrorMessageId(errorInfo);
                        values = messageId === "ui-czna-users.error.organizationHasActiveUsers"
                            ? { count: extractActiveUserCount(errorInfo.message) }
                            : {};
                        openErrorModal(intl.formatMessage({ id: messageId }, values));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    var restoreMutation = useMutation(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, ky.put("czna-users/organizations/".concat(id), {
                        json: {
                            name: organization.name,
                            sigla: organization.sigla,
                            status: OrganizationStatusEnum.ACTIVE,
                            version: organization.version,
                        },
                    })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, {
        onSuccess: function () {
            var _a;
            queryClient.invalidateQueries(["czna-organizations"]);
            (_a = calloutRef.current) === null || _a === void 0 ? void 0 : _a.sendCallout({
                type: "success",
                message: intl.formatMessage({
                    id: "ui-czna-users.organizations.restore.success",
                }),
            });
        },
        onError: function (err) { return __awaiter(void 0, void 0, void 0, function () {
            var errorInfo, messageId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getErrorInfo(err)];
                    case 1:
                        errorInfo = _a.sent();
                        if (isOptimisticLockConflict(errorInfo)) {
                            setShowConflictModal(true);
                            return [2 /*return*/];
                        }
                        messageId = getOrganizationErrorMessageId(errorInfo);
                        openErrorModal(intl.formatMessage({ id: messageId }));
                        return [2 /*return*/];
                }
            });
        }); },
    });
    /**
     * CZNA-1603: archive/restore was refused because somebody saved the organization since this
     * detail was loaded. Loads the current detail — the version the next attempt will send.
     */
    var handleConflictReload = function () { return __awaiter(void 0, void 0, void 0, function () {
        var result, errorInfo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setShowConflictModal(false);
                    return [4 /*yield*/, refetch()];
                case 1:
                    result = _a.sent();
                    if (!!result.isSuccess) return [3 /*break*/, 3];
                    return [4 /*yield*/, getErrorInfo(result.error)];
                case 2:
                    errorInfo = _a.sent();
                    openErrorModal(intl.formatMessage({ id: getOrganizationErrorMessageId(errorInfo) }));
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var handleEdit = function () {
        onEdit(id);
    };
    var handleArchive = function () {
        setShowArchiveModal(true);
    };
    var handleConfirmArchive = function () {
        setShowArchiveModal(false);
        archiveMutation.mutate();
    };
    var handleRestore = function () {
        setShowRestoreModal(true);
    };
    var handleConfirmRestore = function () {
        setShowRestoreModal(false);
        restoreMutation.mutate();
    };
    var isActive = (organization === null || organization === void 0 ? void 0 : organization.status) === OrganizationStatusEnum.ACTIVE;
    var actionMenu = function (_a) {
        var onToggle = _a.onToggle;
        return (React.createElement(React.Fragment, null,
            canEditOrganization && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    handleEdit();
                } },
                React.createElement(Icon, { icon: "edit" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.edit" })))),
            canArchiveOrganization && isActive && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    handleArchive();
                } },
                React.createElement(Icon, { icon: "archive" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.archive" })))),
            canArchiveOrganization && !isActive && (React.createElement(Button, { buttonStyle: "dropdownItem", onClick: function () {
                    onToggle();
                    handleRestore();
                } },
                React.createElement(Icon, { icon: "arrow-up" },
                    React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.restore" }))))));
    };
    var paneContent = function () {
        if (!isUuidValid) {
            return (React.createElement(FormattedMessage, { id: "ui-czna-users.error.invalidOrganizationId" }));
        }
        if (isLoading) {
            return React.createElement(Loading, null);
        }
        if (error || !organization) {
            return (React.createElement(FormattedMessage, { id: getLoadFailureMessageId(error, "ui-czna-users.error.organizationNotFound") }));
        }
        return (React.createElement(AccordionSet, null,
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.section.general" }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 4 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.name" }), value: organization.name })),
                    React.createElement(Col, { xs: 4 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.sigla" }), value: organization.sigla || "-" })),
                    React.createElement(Col, { xs: 4 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.status" }), value: React.createElement(StatusBadge, { status: organization.status }) }))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.userCount" }), value: organization.userCount || 0 })))),
            React.createElement(Accordion, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.section.metadata" }) },
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.createdAt" }), value: organization.createdAt ? (React.createElement(FormattedDate, { value: organization.createdAt })) : ("-") })),
                    React.createElement(Col, { xs: 6 },
                        React.createElement(KeyValue, { label: React.createElement(FormattedMessage, { id: "ui-czna-users.updatedAt" }), value: organization.updatedAt ? (React.createElement(FormattedDate, { value: organization.updatedAt })) : ("-") })))),
            React.createElement(AuditLogAccordion, { entityId: id, entityType: "organization", labelId: "ui-czna-users.organizations.section.history", defaultOpen: false })));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Pane, { defaultWidth: "44%", paneTitle: organization ? (organization.name) : (React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.detail" })), onClose: onClose, dismissible: true, actionMenu: !isLoading && organization ? actionMenu : undefined }, paneContent()),
        organization && (React.createElement(React.Fragment, null,
            React.createElement(ConfirmationModal, { open: showArchiveModal, heading: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.archive.confirm.heading" }), message: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.archive.confirm.message", values: { name: organization.name } }), onConfirm: handleConfirmArchive, onCancel: function () { return setShowArchiveModal(false); }, confirmLabel: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.archive" }), isConfirmButtonDisabled: archiveMutation.isLoading }),
            React.createElement(ConfirmationModal, { open: showRestoreModal, heading: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.restore.confirm.heading" }), message: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.restore.confirm.message", values: { name: organization.name } }), onConfirm: handleConfirmRestore, onCancel: function () { return setShowRestoreModal(false); }, confirmLabel: React.createElement(FormattedMessage, { id: "ui-czna-users.organizations.restore" }), isConfirmButtonDisabled: restoreMutation.isLoading }),
            React.createElement(ConfirmationModal, { open: showConflictModal, heading: intl.formatMessage({
                    id: "ui-czna-users.error.optimisticLockConflict.heading",
                }), message: intl.formatMessage({
                    id: "ui-czna-users.error.optimisticLockConflict.message",
                }), confirmLabel: intl.formatMessage({
                    id: "ui-czna-users.error.optimisticLockConflict.reload",
                }), cancelLabel: intl.formatMessage({ id: "ui-czna-users.cancel" }), onConfirm: handleConflictReload, onCancel: function () { return setShowConflictModal(false); } }),
            React.createElement(ActionErrorModal, { open: isErrorOpen, message: errorMessage, onClose: closeErrorModal }),
            React.createElement(Callout, { ref: calloutRef })))));
};
export default OrganizationDetailPane;
